var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.772,
    height: 16.515,
    fill: "#6a6a6a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-542.328 -2872.828)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(542.328 2872.828)",
    fill: "rgba(255,255,255,0)",
    stroke: "#6a6a6a",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.442 2876.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.885,16.515,4.35,15.49C4.2,15.2.64,8.355.089,5.665A4.463,4.463,0,0,1,1.067,1.9,5.1,5.1,0,0,1,4.885,0,5.094,5.094,0,0,1,8.7,1.9a4.464,4.464,0,0,1,.978,3.767C9.13,8.355,5.571,15.2,5.42,15.489Zm0-15.309A3.862,3.862,0,0,0,2,2.66,3.278,3.278,0,0,0,1.27,5.423c.4,1.929,2.585,6.416,3.615,8.461C5.914,11.839,8.1,7.352,8.5,5.423A3.279,3.279,0,0,0,7.769,2.66,3.862,3.862,0,0,0,4.885,1.206Z",
    transform: "translate(0.001)",
    fill: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.414,46.5a2.779,2.779,0,1,1,2.779-2.779A2.782,2.782,0,0,1,40.414,46.5m0-4.351a1.573,1.573,0,1,0,1.573,1.573,1.575,1.575,0,0,0-1.573-1.573",
    transform: "translate(-35.528 -38.654)",
    fill: "#6a6a6a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMap);
export default __webpack_public_path__ + "static/media/grey_map.ad5336b2aa8693e8a37a3037a2e04888.svg";
export { ForwardRef as ReactComponent };